import { Component, OnInit, ViewChild } from '@angular/core';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { AppSettings } from 'pac-api';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { IndividualAffiliationService } from '../individual-affiliation.service';
import { IndividualAffiliationModel } from '../model/individual-affiliation.model';
import { WizardStep } from '../wizard-step';
import { WizardNavigationService } from '../wizard/wizard-navigation.service';

@Component({
  selector: 'app-individual-affiliations',
  templateUrl: './individual-affiliations.component.html',
  styleUrls: ['./individual-affiliations.component.less']
})
export class IndividualAffiliationsComponent implements OnInit, WizardStep {

  public static Name = 'IndividualAffiliationsComponent';
  public Name = 'IndividualAffiliationsComponent';

  public faXmark = faXmark;

  @ViewChild('confirm')
  public confirmModal: ModalDirective;

  public Affiliations$: Observable<IndividualAffiliationModel[]>;

  public Busy: Set<IndividualAffiliationModel>;

  public Alerts: Set<AlertMessage>;

  public Loaded: boolean = false;

  constructor(
    private service: IndividualAffiliationService,
    private navigation: WizardNavigationService,
    public Settings: AppSettings,
  ) {
    this.Busy = new Set();
    this.Alerts = new Set();
  }

  public ngOnInit(): void {
    this.Affiliations$ = this.service.GetAffiliation().pipe(map(affiliations => {
      return affiliations
        .filter(ixo => {
          if (ixo.ixo_end_date) {
            return false;
          }

          return true;
        })
        .sort((a, b) => {
          const i = a.org_group_aie_flag_ext,
              j = b.org_group_aie_flag_ext;

          if (i && !j) {
            return -1;
          } if (!i && j) {
            return 1;
          }

          const x = a.org_name.toLowerCase().trim(),
              y = b.org_name.toLowerCase().trim();

          if (x < y) {
            return -1;
          } if (x > y) {
            return 1;
          }

          return 0;
        });
    }), tap(affiliations => {
      if (affiliations) {
        if (affiliations.length === 0) {
          this.navigation.next(this);
        } else {
          this.Loaded = true;
        }
      }
    }));
  }

  public ready(): boolean {
    return true;
  }

  public Save(): void {
    this.navigation.next(this);
  }

  public Delete(affilitation: IndividualAffiliationModel, confirm: boolean = false): void {
    if (! confirm && affilitation.org_group_aie_flag_ext) {
      this.Busy.add(affilitation);
      (<ModalOptions<IndividualAffiliationModel>>this.confirmModal.config).initialState = affilitation;
      this.confirmModal.show();
      return;
    }

    if (confirm) {
      if (this.confirmModal) {
        this.confirmModal.hide();
      }
    } else {
      if (this.Busy.has(affilitation)) {
        return;
      }

      this.Busy.add(affilitation);
    }

    this.service.DeleteAffilication(affilitation).subscribe(deleted => {
      this.Alerts.add({
        type: 'info',
        msg: `<em>${deleted.rlt_code}</em> relationship to <strong>${deleted.org_name}</strong> has been removed.`
      });
    });
  }

  public alertOnClosed(alert: AlertMessage): void {
    this.Alerts.delete(alert);
  }

  public confirmModalClose() {
    if (this.confirmModal && this.confirmModal.config.initialState instanceof IndividualAffiliationModel) {
      this.Busy.delete(this.confirmModal.config.initialState);
      this.confirmModal.config.initialState = null;
    }
  }
}

interface AlertMessage {
  type: 'success' | 'info' | 'warning' | 'danger';
  msg: string;
}
